import React from 'react'
import { show, getConfig } from '../twd'
import { useAppContext } from '../App'

export default () => {
    const { view } = useAppContext()

    return <React.Fragment>
    <div className={ view==='portfolio-report' ? 'row' : 'row vertical-offset-sm'} >
    <div className="col-xs-12">

    <div data-name="header-nav-tabs" className="nav-tabs nav-tabs-border">
    <ul role="tablist">
        <li role="presentation"
            className={ !view || view==='overview' ? 'active' : '' }>
            <button
                data-name="header-overview-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ !view || view==='overview' }
                onClick={() => show('overview')}
            >Overview</button>
        </li>
        <li role="presentation"
            className={ view==='corporates' ? 'active' : '' }>
            <button
                data-name="header-corporates-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ view==='corporates' }
                onClick={() => show('corporates')}
            >Corporates</button>
        </li>
        <li role="presentation"
            className={ view==='municipals' ? 'active' : '' } >
            <button
                data-name="header-municipals-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ view==='municipals' }
                onClick={() => show('municipals')}
            >Municipals</button>
        </li>
        <li role="presentation"
            className={ view==='advanced-screener' || view==='offerings' || view==='search-results' ? 'active' : '' }>
            <button
                data-name="header-advanced-screener-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ view==='advanced-screener' || view==='offerings' || view==='search-results' }
                onClick={() => show('advanced-screener')}
            >Advanced Screener</button>
        </li>
        <li role="presentation"
            className={ view==='tools-and-resources' || view==='tools' || view==='treasury-auctions' || view==='portfolio-report' ? 'active' :'' }>
            <button
                data-name="header-tools-and-resources-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ view==='tools-and-resources' || view==='tools' || view==='treasury-auctions' || view==='portfolio-report' }
                onClick={() => show('tools-and-resources')}
            >Tools and Resources</button>
        </li>
        { getConfig('entitlements.ETradeOrderTicket', 'No') === 'Yes'
        ? <li role="presentation"
            className={ view==='order-ticket' ? 'active' :'' }>
            <button
                data-name="header-order-ticket-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ view==='order-ticket'  }
                onClick={() => show('order-ticket', { ts:Date.now() })}
            >Place a Trade</button>
        </li>
        : null }
    </ul>
    </div>

    </div>
    </div>
    </React.Fragment>
}
